__turbopack_context__.v({
  "accordionContent": "n9JJ9a_accordionContent",
  "animatedFadeIn": "n9JJ9a_animatedFadeIn",
  "fadeIn": "n9JJ9a_fadeIn",
  "fadeOut": "n9JJ9a_fadeOut",
  "slideDown": "n9JJ9a_slideDown",
  "slideUp": "n9JJ9a_slideUp",
});
